import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import AudienceProviderInfoHolder from "../../styles/audienceProviderInfoStyle";
import genericAudience from "../../../../../images/generic-audience-icon.png";

const SCREEN_OWNER_PROVIDER_ID = 2;

const AudienceProviderInfo = ({ displays, view = "quantitative" }) => {
  const { t } = useTranslation();
  const [providerList, setProviders] = useState([]);

  const removeDuplicates = (arr) =>
    Array.from(new Set(arr.map(JSON.stringify)), JSON.parse);

  const getProviderName = (provider) =>
    provider.id !== SCREEN_OWNER_PROVIDER_ID ? provider.stylized_name : t("display owner");

  const getProviderImg = (provider) =>
    provider && provider.image ? provider.image : genericAudience;

  const sanitizeDisplayProviders = () =>
    displays.map((d) => {
      if (view === "qualitative") {
        if (!d.qualitative_audience_provider_id) {
          return {
            ...d,
            qualitative_audience_provider_id: SCREEN_OWNER_PROVIDER_ID,
            qualitative_audience_provider: { id: SCREEN_OWNER_PROVIDER_ID },
          };
        }
      } else if (view === "quantitative") {
        if (!d.audience_provider_id) {
          return {
            ...d,
            audience_provider_id: SCREEN_OWNER_PROVIDER_ID,
            audience_provider: { id: SCREEN_OWNER_PROVIDER_ID },
          };
        }
      }
      return d;
    });

  useEffect(() => {
    if (displays && displays.length > 0) {
      const auxDisplays = sanitizeDisplayProviders();
      const uniqueProviders = removeDuplicates(
        view === "qualitative"
          ? auxDisplays
              .filter((d) => d.qualitative_audience_provider_id)
              .map((d) => d.qualitative_audience_provider)
          : auxDisplays
              .filter((d) => d.audience_provider_id)
              .map((d) => d.audience_provider)
      );
      setProviders(uniqueProviders);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [displays, view]);

  const oneScreen = displays && displays.length === 1;
  const providedByLabel = oneScreen
    ? t("Audience data for this screen provided by")
    : t("Audience data for these screens provided by");

  if (!providerList.length) return null;

  return (
    <AudienceProviderInfoHolder>
      <div className="audience-provider-info-component">
        {providerList.length < 2 && (
          <div className="provider-container">
            <img src={getProviderImg(providerList[0])} className="provider-image" alt="" />
            <div>
              {providedByLabel}{" "}
              {providerList[0].url ? (
                <a href={providerList[0].url} target="_blank" rel="noopener noreferrer">
                  {getProviderName(providerList[0])}
                </a>
              ) : (
                <span>{getProviderName(providerList[0])}</span>
              )}
            </div>
          </div>
        )}
        {providerList.length >= 2 && (
          <div className="provider-container">
            {providedByLabel} :
            <div className="external-provider-names">
              {providerList.map((provider, index) => (
                <span key={index}>
                  {index !== 0 && <span>&nbsp;/&nbsp;</span>}
                  <img src={getProviderImg(provider)} className="small-provider-image" alt="" />
                  {provider.url ? (
                    <a href={provider.url} target="_blank" rel="noopener noreferrer">
                      {getProviderName(provider)}
                    </a>
                  ) : (
                    <span>{getProviderName(provider)}</span>
                  )}
                </span>
              ))}
            </div>
          </div>
        )}
      </div>
    </AudienceProviderInfoHolder>
  );
};

export default AudienceProviderInfo;
